module.exports = __webpack_public_path__ + "static/media/minnesota-me.71b9cf3c.jpg";